// extracted by mini-css-extract-plugin
module.exports = {"showFiltersMessage":"hideFilterHotel_showFiltersMessage__2uTN5"};